/* ============================================================
 * FAQ-Wissensdatenbank (faq-hub)
 *   - Live-Suche über alle Fragen (filtert + klappt Treffer auf)
 *   - Trefferzähler (Live-Region), Suchbegriff-Highlight, Clear-Button
 *   - Navigation synchron: Kategorien ohne Treffer abgeblendet, Zähler live
 *   - Scroll-Spy: aktive Kategorie in der Navigation markieren
 * Pro <div class="faqx"> eigenständig initialisiert.
 * ============================================================ */
(function () {
  'use strict';

  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  // Suchbegriff im Container mit <mark> auszeichnen. Arbeitet ausschließlich
  // auf Textknoten, damit die HTML-Struktur (Links, Listen, Fett) intakt bleibt.
  function markText(container, term) {
    if (!container || !term) return;
    var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    var node;
    while ((node = walker.nextNode())) nodes.push(node);

    nodes.forEach(function (textNode) {
      var text = textNode.nodeValue;
      var hay = norm(text);
      // Nur markieren, wenn die Normalisierung die Länge erhält – nur dann ist
      // das Index-Mapping normalisiert→original verlässlich (gilt für dt. Text).
      if (hay.length !== text.length) return;

      var idx = hay.indexOf(term);
      if (idx === -1) return;

      var frag = document.createDocumentFragment();
      var last = 0;
      while (idx !== -1) {
        if (idx > last) frag.appendChild(document.createTextNode(text.slice(last, idx)));
        var mark = document.createElement('mark');
        mark.className = 'faqx__mark';
        mark.textContent = text.slice(idx, idx + term.length);
        frag.appendChild(mark);
        last = idx + term.length;
        idx = hay.indexOf(term, last);
      }
      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      textNode.parentNode.replaceChild(frag, textNode);
    });
  }

  function setup(root) {
    var input = root.querySelector('.faqx__search-input');
    var clear = root.querySelector('.faqx__search-clear');
    var result = root.querySelector('.faqx__result');
    var resultNum = result ? result.querySelector('.faqx__result-num') : null;
    var resultTerm = result ? result.querySelector('.faqx__result-term') : null;
    var empty = root.querySelector('.faqx__empty');
    var emptyTerm = empty ? empty.querySelector('.faqx__empty-term') : null;
    var cats = Array.prototype.slice.call(root.querySelectorAll('.faqx__cat'));
    var links = Array.prototype.slice.call(root.querySelectorAll('.faqx__nav a'));

    // Fragen einsammeln + Originalzustand sichern (für Restore + Highlight).
    var qa = Array.prototype.slice.call(root.querySelectorAll('.faqx__qa')).map(function (el) {
      var summary = el.querySelector('.faqx__summary');
      var answer = el.querySelector('.faqx__answer');
      return {
        el: el,
        summary: summary,
        answer: answer,
        hay: norm(el.textContent),
        summaryHTML: summary ? summary.innerHTML : '',
        answerHTML: answer ? answer.innerHTML : ''
      };
    });

    // id → Nav-Link; Original-Zähler für den Reset sichern.
    var byId = {};
    links.forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) === '#') byId[href.slice(1)] = a;
      var cnt = a.querySelector('.faqx__nav-cnt');
      if (cnt) cnt.setAttribute('data-total', cnt.textContent.trim());
    });

    // ---- Live-Suche ----
    if (input) {
      var runSearch = function () {
        var raw = input.value.trim();
        var term = norm(raw);
        var count = 0;

        qa.forEach(function (q) {
          var match = !term || q.hay.indexOf(term) !== -1;
          q.el.hidden = !match;
          q.el.open = !!term && match;
          // Vorherige Markierungen entfernen (Originalzustand wiederherstellen).
          if (q.summary) q.summary.innerHTML = q.summaryHTML;
          if (q.answer) q.answer.innerHTML = q.answerHTML;
          if (match && term) {
            count++;
            markText(q.summary, term);
            markText(q.answer, term);
          }
        });

        // Kategorien + Navigation synchronisieren.
        cats.forEach(function (c) {
          var vis = c.querySelectorAll('.faqx__qa:not([hidden])').length;
          c.hidden = !!term && vis === 0;
          var link = byId[c.id];
          if (!link) return;
          link.classList.toggle('is-empty', !!term && vis === 0);
          var cnt = link.querySelector('.faqx__nav-cnt');
          if (cnt) cnt.textContent = term ? vis : cnt.getAttribute('data-total') || cnt.textContent;
        });

        // Trefferzähler (nur bei ≥1 Treffer) …
        if (result) {
          var show = !!term && count > 0;
          result.hidden = !show;
          if (show) {
            if (resultNum) resultNum.textContent = count;
            if (resultTerm) resultTerm.textContent = '„' + raw + '“';
          }
        }
        // … Empty-State (nur bei 0 Treffern), gibt den Begriff zurück.
        if (empty) {
          var none = !!term && count === 0;
          empty.hidden = !none;
          if (none && emptyTerm) emptyTerm.textContent = '„' + raw + '“';
        }

        if (clear) clear.hidden = !raw;
      };

      input.addEventListener('input', runSearch);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && input.value) {
          input.value = '';
          runSearch();
        }
      });

      if (clear) {
        clear.addEventListener('click', function () {
          input.value = '';
          runSearch();
          input.focus();
        });
      }
    }

    // ---- Scroll-Spy ----
    if ('IntersectionObserver' in window && cats.length) {
      var spy = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            links.forEach(function (a) {
              a.classList.remove('is-active');
            });
            var link = byId[e.target.id];
            if (!link) return;
            link.classList.add('is-active');
            // Aktiven Chip auf Mobile horizontal zentrieren – NUR den Nav-Container,
            // nie den Seiten-Scroll (kein scrollIntoView).
            var ul = link.closest('ul');
            if (ul && ul.scrollWidth > ul.clientWidth) {
              ul.scrollTo({ left: link.offsetLeft - ul.clientWidth / 2 + link.offsetWidth / 2, behavior: 'smooth' });
            }
          });
        },
        { rootMargin: '-15% 0px -75% 0px', threshold: 0 }
      );
      cats.forEach(function (c) {
        spy.observe(c);
      });
    }
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('.faqx')).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
